import React from 'react';
import {useNoticesUIContext} from "../NoticesUIContext";
import {useMemo} from "react";
import {isEqual} from "lodash";
import {Formik} from "formik";

const prepareFilter = (queryParams, values) => {
    const { searchText } = values;

    const newQueryParams = { ...queryParams };
    const filter = {};

    if (searchText) {
        filter.name = searchText;
    }

    newQueryParams.filter = filter;
    return newQueryParams;
};


export function NoticesFilter({listLoading}) {{
    const noticesUIContext = useNoticesUIContext();
    
    const noticesUIProps = useMemo(() => {
        return{
            queryParams: noticesUIContext.queryParams,
            setQueryParams: noticesUIContext.setQueryParams,
        }
    }, [noticesUIContext])

    const applyFilter = (values) => {
        const newQueryParams = prepareFilter(noticesUIProps.queryParams, values);
        if (!isEqual(newQueryParams, noticesUIProps.queryParams)) {
            newQueryParams.pageNumber = 1;
            noticesUIProps.setQueryParams(newQueryParams);
        }
    };
    
    return(
        <>
            
            <Formik initialValues={{searchText: ""}} onSubmit={(values) => applyFilter(values)}>
                {({values, handleSubmit, handleBlur, setFieldValue}) => (
                    <form onSubmit={handleSubmit} className={'form form-label-right'}>
                        <div className="form-group row">
                            <div className="col-lg-2">
                                <input
                                    type={'text'}
                                    className={'form-control'}
                                    name={'searchText'}
                                    placeholder={'جستجو'}
                                    onBlur={handleBlur}
                                    value={values.searchText}
                                    onChange={(e) => {
                                        setFieldValue("searchText", e.target.value);
                                        handleSubmit();
                                    }}
                                    />
                            </div>
                        </div>
                    </form>
                )}
            </Formik>
        
        </>
    )
    
    
}}